module.exports = __webpack_public_path__ + "static/img/3.9d3ffcef.jpg";